export default __webpack_public_path__ + "static/media/logoBankwest32.3c207a28.svg";